export function formatDuration(seconds: number) {
  const pad = (num: number) => num.toString().padStart(2, '0');
  const sec = Math.floor(seconds % 60);
  const min = Math.floor((seconds / 60) % 60);
  const hours = Math.floor(seconds / 3600);
  return `${hours}:${pad(min)}:${pad(sec)}`;
}
